import { EstatusDocumento } from "../../../constant/catEstatusDocumento"
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { Tooltip } from "@material-ui/core";
const EstatusDocumentoLabel = (props) => {
    const { estatus } = props
    switch (estatus) {
        case EstatusDocumento.NoAplica:
            return <div>N/A</div>
        case EstatusDocumento.DOCUMENTO:
            return  (
                <Tooltip title="Documentación completa">
                     <CheckCircleIcon color='secondary' />
                </Tooltip>
            )
        case EstatusDocumento.SIN_DOCUMENTO:
            return  (
                <Tooltip title="Falta documentación">
                    <ErrorIcon style={{color: "#B89130"}} />
                </Tooltip>
            )
        default:
            return <div>N/A</div>
    }
}
export default EstatusDocumentoLabel